import React from 'react';
import { Input } from 'antd';

export default props => <Input.Search {...props} />;
